import { Col, Divider, Form, FormInstance, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import OsxFinancialMoreOptions from '../OsXFinancialMoreOptions';
import OsxFinancialOverviewForm from '../OsxFinancialOverviewForm';
import OsXFinancialWithoutFinancialDivergentValueForm from '../OsXFinancialWithoutFinancialDivergentValueForm';
import {
  OsXFinancialFilterDateBy,
  OsXFinancialFilterOsBy,
  OsXFinancialReportType,
  QuestReportOsXFinancialFormValues,
} from '@/core/domain/questReport/Reports/OsXFinancial/OsXFinancial.types';
import { useEffect } from 'react';

interface Props {
  form: FormInstance<QuestReportOsXFinancialFormValues>;
}

const OsXFinancialForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();

  const { Title } = Typography;

  const reportType = Form.useWatch('reportType', form);
  const filterDateBy = Form.useWatch('filterDateBy', form);

  useEffect(() => {
    if (reportType === OsXFinancialReportType.noFinancialOrDivergentValue) {
      form.setFieldValue('filterDateBy', OsXFinancialFilterDateBy.delivery);
    }

    if (reportType === OsXFinancialReportType.overview) {
      form.setFieldValue('filterDateBy', OsXFinancialFilterDateBy.os);
    }
  }, [reportType]);

  useEffect(() => {
    if (filterDateBy === OsXFinancialFilterDateBy.os) {
      form.setFieldValue('filterOsBy', OsXFinancialFilterOsBy.delivery);
    }

    if (filterDateBy === OsXFinancialFilterDateBy.financial) {
      form.setFieldValue('filterOsBy', OsXFinancialFilterOsBy.emission);
    }
  }, [filterDateBy]);

  return (
    <Form form={form} layout="vertical">
      <ReportSelectMonthFields
        form={form}
        dateFilter={
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const reportType = getFieldValue('reportType');

              return (
                <>
                  {reportType ===
                  OsXFinancialReportType.noFinancialOrDivergentValue ? (
                    <>
                      <Title level={5}>
                        {intl.formatMessage({
                          id: 'movimentOsXFinancial.form.reportType.filterByDateFrom',
                        })}
                      </Title>

                      <Form.Item
                        name="filterDateBy"
                        initialValue={OsXFinancialFilterDateBy.delivery}
                        noStyle
                      >
                        <Radio.Group
                          optionType="button"
                          buttonStyle="solid"
                          size="large"
                        >
                          <Radio value={OsXFinancialFilterDateBy.delivery}>
                            {intl.formatMessage({
                              id: 'movimentOsXFinancial.form.reportType.delivery',
                            })}
                          </Radio>
                          <Radio value={OsXFinancialFilterDateBy.authorization}>
                            {intl.formatMessage({
                              id: 'movimentOsXFinancial.form.reportType.authorization',
                            })}
                          </Radio>
                          <Radio value={OsXFinancialFilterDateBy.closure}>
                            {intl.formatMessage({
                              id: 'movimentOsXFinancial.form.reportType.closure',
                            })}
                          </Radio>
                        </Radio.Group>
                      </Form.Item>
                    </>
                  ) : (
                    <>
                      <Title level={5}>
                        {intl.formatMessage({
                          id: 'movimentOsXFinancial.form.reportType.filterByDateFrom',
                        })}
                      </Title>

                      <Form.Item
                        name="filterDateBy"
                        noStyle
                        initialValue={OsXFinancialFilterDateBy.os}
                        shouldUpdate
                      >
                        <Radio.Group
                          optionType="button"
                          buttonStyle="solid"
                          size="large"
                        >
                          <Radio value={OsXFinancialFilterDateBy.os}>
                            {intl.formatMessage({
                              id: 'movimentOsXFinancial.form.overview.filterByDate.os',
                            })}
                          </Radio>
                          <Radio value={OsXFinancialFilterDateBy.financial}>
                            {intl.formatMessage({
                              id: 'movimentOsXFinancial.form.overview.filterByDate.financial',
                            })}
                          </Radio>
                        </Radio.Group>
                      </Form.Item>
                    </>
                  )}
                </>
              );
            }}
          </Form.Item>
        }
      />

      <Row gutter={[24, 24]}>
        <Col>
          <Title level={5}>
            {intl.formatMessage({
              id: 'movementOsXFinancial.form.selectReportType',
            })}
          </Title>

          <Form.Item
            name="reportType"
            noStyle
            initialValue={OsXFinancialReportType.noFinancialOrDivergentValue}
          >
            <Radio.Group optionType="button" buttonStyle="solid" size="large">
              <Radio value={OsXFinancialReportType.noFinancialOrDivergentValue}>
                {intl.formatMessage({
                  id: 'movimentOsXFinancial.form.reportType.noFinancialDivergentValue',
                })}
              </Radio>

              <Radio value={OsXFinancialReportType.overview}>
                {intl.formatMessage({
                  id: 'movimentOsXFinancial.form.reportType.overview',
                })}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              const reportType = getFieldValue('reportType');

              return (
                <>
                  {reportType ===
                  OsXFinancialReportType.noFinancialOrDivergentValue ? (
                    <OsXFinancialWithoutFinancialDivergentValueForm />
                  ) : (
                    <OsxFinancialOverviewForm />
                  )}
                </>
              );
            }}
          </Form.Item>
        </Col>

        <OsxFinancialMoreOptions />

        <Divider />
      </Row>
    </Form>
  );
};

export default OsXFinancialForm;
